import PropTypes from 'prop-types';
import MinusPlusButtons from '@utilities/components/MinusPlusButtons';
import styles from './_index.module.scss';

const AllocatedCreditsCell = ({
  disableMinus,
  disablePlus,
  isEditable,
  onDecrement,
  onIncrement,
  value,
}) => {
  return (
    <span
      className={styles['allocated-credits-cell']}
      onMouseDown={(e) => e.stopPropagation()}
      onPointerDown={(e) => e.stopPropagation()}
    >
      {isEditable && (
        <MinusPlusButtons
          disableMinusButton={disableMinus}
          hasPlusButton={false}
          isNeutral={value === 0}
          onClickMinus={onDecrement}
        />
      )}
      <span className={styles['allocated-credits-value']}>{value}</span>
      {isEditable && (
        <MinusPlusButtons
          disablePlusButton={disablePlus}
          hasMinusButton={false}
          onClickPlus={onIncrement}
        />
      )}
    </span>
  );
};

AllocatedCreditsCell.propTypes = {
  disableMinus: PropTypes.bool,
  disablePlus: PropTypes.bool,
  isEditable: PropTypes.bool.isRequired,
  onDecrement: PropTypes.func.isRequired,
  onIncrement: PropTypes.func.isRequired,
  value: PropTypes.number.isRequired,
};

AllocatedCreditsCell.defaultProps = {
  disableMinus: false,
  disablePlus: false,
};

export default AllocatedCreditsCell;
